/*
	toast.info("info");
    toast.success("success");
    toast.warn("warning");
    toast.error("error");
    toast("default");
    toast.dark("dark");
*/

import React from "react";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toastify = (props) => {
  return <ToastifyStyle {...props} autoClose={3000} hideProgressBar={true} />;
};
export default Toastify;

const ToastifyStyle = styled(ToastContainer)`
  z-index: 101;
  top: 55px;
  font-family: "Poppins Regular";
  font-size: 14px;

  .Toastify__toast {
    min-height: auto;

    &--info {
      background-color: #0275d8;
    }
    &--success {
      background-color: #5cb85c;
    }
    &--warning {
      background-color: #f0ad4e;
    }
    &--error {
      background-color: ${({ theme }) => theme.color.danger};
    }
    &--default {
      background-color:${({ theme }) => theme.color.secondaryBg};
      color: ${({ theme }) => theme.color.darkerText};
    }
    &--dark {
      background-color: ${({ theme }) => theme.color.background};
    }

  }
`;
